import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { ColumnConfig } from '@/components/table/Table';
import { appUrl } from '@/utils/appUrl';

export const getDriverDebtModalColumns = (): ColumnConfig[] => [
  {
    label: 'ID Pedido',
    field: 'shippingNumber',
    render: (value) => (
      <span
        className='flex items-center gap-1.5 text-sm font-bold text-blue-600 hover:underline cursor-pointer'
        onClick={() => window.open(appUrl(`/business/shipping/${value}`), '_blank')}
      >
        <OpenInNewIcon sx={{ fontSize: 13 }} />
        {value}
      </span>
    ),
  },
  {
    label: 'Destinatario',
    field: 'recipient',
    render: (value) => <span className='text-sm text-gray-700'>{value || '-'}</span>,
  },
  {
    label: 'Comercio',
    field: 'commerceName',
    render: (value) => <span className='text-sm text-gray-700'>{value || '-'}</span>,
  },
  {
    label: 'Dirección',
    field: 'address',
    render: (value) => <span className='text-sm text-gray-700'>{value || '-'}</span>,
  },
  {
    label: 'Estado',
    field: 'statusCommercialName',
    render: (value, row) => (
      <span className='text-sm text-gray-700'>
        {value || row.statusName || '-'}
      </span>
    ),
  },
];
